export const FABRICS_01 = { uid: 'white', name: "White", filename: "White.png", group: "fabrics_colors", price: 0 };
export const FABRICS_02 = { uid: 'smog', name: "Smog", filename: "Smog.png", group: "fabrics_colors", price: 0 };
export const FABRICS_03 = { uid: 'plata', name: "Plata", filename: "Plata.png", group: "fabrics_colors", price: 0 };
export const FABRICS_04 = { uid: 'whale', name: "Whale", filename: "Whale.png", group: "fabrics_colors", price: 0 };
export const FABRICS_05 = { uid: 'ice_cream', name: "Ice Cream", filename: "IceCream.png", group: "fabrics_colors", price: 0 };
export const FABRICS_06 = { uid: 'sisal', name: "Sisal", filename: "Sisal.png", group: "fabrics_colors", price: 0 };
export const FABRICS_07 = { uid: 'macadamia', name: "Macadamia", filename: "Macadamia.png", group: "fabrics_colors", price: 0 };
export const FABRICS_08 = { uid: 'sandstone', name: "Sandstone", filename: "Sandstone.png", group: "fabrics_colors", price: 0 };
export const FABRICS_09 = { uid: 'sage', name: "Sage", filename: "Sage.png", group: "fabrics_colors", price: 0 };
export const FABRICS_10 = { uid: 'hunter', name: "Hunter", filename: "Hunter.png", group: "fabrics_colors", price: 0 };
export const FABRICS_11 = { uid: 'mizzle', name: "Mizzle", filename: "Mizzle.png", group: "fabrics_colors", price: 0 };
export const FABRICS_12 = { uid: 'jet', name: "Jet", filename: "Jet.png", group: "fabrics_colors", price: 0 };
export const FABRICS_13 = { uid: 'umber', name: "Umber", filename: "Umber.png", group: "fabrics_colors", price: 0 };
export const FABRICS_14 = { uid: 'sunskit', name: "Sunkist", filename: "Sunkist.png", group: "fabrics_colors", price: 0 };
export const FABRICS_15 = { uid: 'orange', name: "Orange", filename: "Orange.png", group: "fabrics_colors", price: 0 };
export const FABRICS_ALL = [
    FABRICS_01,
    FABRICS_02,
    FABRICS_03,
    FABRICS_04,
    FABRICS_05,
    FABRICS_06,
    FABRICS_07,
    FABRICS_08,
    FABRICS_09,
    FABRICS_10,
    FABRICS_11,
    FABRICS_12,
    FABRICS_13,
    FABRICS_14,
    FABRICS_15,
];
